import React, { useState, useCallback, useMemo, useRef } from 'react';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import PropTypes from 'prop-types';
import defaultImage from '../../../assets/images/shop/ImageNotFound.svg';

export const CategoryGridBulb = ({ id, url, imgSrc, label }) => {
  const [hasImageError, setImageError] = useState(false);
  const ref = useRef();

  const imageSrc = useMemo(() => {
    if (hasImageError) return defaultImage;

    return imgSrc || defaultImage;
  }, [hasImageError, imgSrc]);

  const handleImageError = useCallback(() => {
    setImageError(true);
  }, []);

  return (
    <div key={id} className="category-grid__category">
      <LinkV2 variant="primary" noUnderline size="small" href={url}>
        <img
          ref={ref}
          className="category-grid__img"
          src={imageSrc}
          onError={handleImageError}
          alt={label}
        />
        <div className="category-grid__img-caption">{label}</div>
      </LinkV2>
    </div>
  );
};

CategoryGridBulb.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  imgSrc: PropTypes.string,
  label: PropTypes.string,
};

export default CategoryGridBulb;
